@if (!pdfView) {
    <div class="d-inline-flex justify-content-between">
        <h3 appTitleProvider>{{ 'ALLOCATED_TASKS' | translate }}</h3>
        <div>
            <span class="mr-2" appTitleProvider>{{ 'TASKS_ADDRESS_TOGGLE' | translate }}</span>
            <app-toggle (change)="addressToggle()"></app-toggle>
        </div>
    </div>
}
<div class="container-flex h-100">
    @if (!pdfView) {
        <app-table
            [ngClass]="{
        'drop-disabled': draggingTask && employee.dropDisabled,
        'drop-enabled': draggingTask && !employee.dropDisabled
    }"
            [disableHover]="draggingTask && employee.dropDisabled"
            [loadingTable]="updating || saving"
            [loadingTableText]="saving ? '' : 'ESTIMATING_NEW_VISITING_TIMES'"
            class="tasks-table"
        >
            <ng-container header>
                <th class="travel-time-column"></th>
                <th class="index-column"></th>
                <th class="flex-1" appTitleProvider>
                    <span>{{ 'NAME' | translate }}</span>
                </th>
                <th class="flex-3 task-description" appTitleProvider>
                    <span>{{ 'TASK' | translate }}</span>
                </th>
                @if (showRoster) {
                    <th class="flex-1" appTitleProvider>
                        <span>{{ 'ROSTER_NAME' | translate }}</span>
                    </th>
                }
                <th class="flex-2" appTitleProvider>
                    <span>{{ 'ESTIMATED_VISIT' | translate }}</span>
                </th>
                <th class="flex-2" appTitleProvider>
                    <span>{{ 'TIME_WINDOW' | translate }}</span>
                </th>
                <th class="icon-column two"></th>
                <th class="icon-drag-column"></th>
            </ng-container>
            <ng-container body>
                <cdk-virtual-scroll-viewport
                    class="d-flex h-100"
                    (contextmenu)="getMousePosition($event)"
                    itemSize="33"
                    orientation="vertical"
                >
                    <div class="d-inline-flex w-100 row-tasks">
                        <div>
                            @for (routeTask of routeTasks; track routeTask.taskId; let taskIndex = $index) {
                                <div class="travel-time-container d-flex mr-1">
                                    <div class="d-flex flex-row times-container">
                                        <div class="free-time-content time-content mx-auto mr-1 flex-1"
                                        >
                                            @if (routeTask.freeTimeBeforeTask > 0 && taskIndex > 0 && (showFreeTimeBetweenTasksFeature | async)) {
                                                <app-tooltip
                                                    appCustomPopover
                                                    placement="left"
                                                    popoverText="TASK_FREE_TIME"
                                                >
                                                    <ng-container icon>
                                                        <span class="text-green text-left mx-auto
                                                            font-weight-bold free-time-background">
                                                            {{ routeTask.freeTimeBeforeTask }}
                                                        </span>
                                                    </ng-container>
                                                </app-tooltip>
                                            }
                                        </div>
                                        <div class="flex-2">
                                            <div class="travel-time-content time-content mx-auto">
                                                <app-tooltip
                                                    appCustomPopover
                                                    popoverText="{{ 'TRAVEL_TIME_TASK_TOOLTIP' | translate: {from: (getTaskFromAddress(taskIndex) | translate), to: (getTaskToAddress(taskIndex) | translate)} }}"
                                                    placement="left"
                                                    [compact]="true"
                                                    class="mx-auto"
                                                >
                                                    <ng-container icon>
                                                        <div class="mx-auto d-flex flex-row">
                                                            @if (showRideSharingTask(taskIndex)) {
                                                                <div>
                                                                    @if (routeTask.showIcon && routeTask.rideSharingIcon) {
                                                                        <img
                                                                            class="w-100"
                                                                            src="/assets/images/icons/24_car_ride_sharing.svg"
                                                                            alt="{{'RIDE_SHARING' | translate}}"
                                                                        >
                                                                    }
                                                                </div>
                                                            }
                                                            @if (routeTask.showIcon && !routeTask.rideSharingIcon) {
                                                                <div>
                                                                    @switch (employee.transport) {
                                                                        @case (transportTypes.Drive) {
                                                                            <img
                                                                                class="w-100"
                                                                                src="/assets/images/icons/24_car.svg"
                                                                                alt="{{'DRIVE' | translate}}"
                                                                            >
                                                                        }
                                                                        @case (transportTypes.Walk) {
                                                                            <img
                                                                                class="w-100"
                                                                                src="/assets/images/icons/24_walking.svg"
                                                                                alt="{{'WALK' | translate}}"
                                                                            >
                                                                        }
                                                                        @case (transportTypes.Bicycle) {
                                                                            <img
                                                                                class="w-100"
                                                                                src="/assets/images/icons/24_bicycle.svg"
                                                                                alt="{{'BICYCLE' | translate}}"
                                                                            >
                                                                        }
                                                                    }
                                                                </div>
                                                            }
                                                            <span class="mx-auto pl-1 black justify-content-center"
                                                                  [ngClass]="{'ride-sharing-travel-time': showRideSharingTask(taskIndex)}"
                                                            >
                                                                {{ (routeTask.travelTimeFromPrev !== undefined ? routeTask.travelTimeFromPrev : "?") + "'" }}
                                                            </span>
                                                        </div>
                                                    </ng-container>
                                                </app-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="{
                                         'connection-line-last': taskIndex === routeTasks.length - 1 && !routeTask.isShiftSplitTask,
                                         'connection-line-last-split': taskIndex === routeTasks.length - 1 && routeTask.isShiftSplitTask,
                                         'disabled': endLocationTravelTime === null || !(showTravelTimeBackToOffice | async),
                                         'connection-line-split': routeTask.isShiftSplitTask,
                                         'connection-line-address-toggle': addressToggleValue,
                                         'connection-line-address-toggle-split': addressToggleValue && routeTask.isShiftSplitTask}"
                                         class="connection-line position-top"
                                    >
                                    </div>
                                    @if ((taskIndex === routeTasks.length - 1) && endLocationTravelTime !== null && (showTravelTimeBackToOffice | async)) {
                                        <div
                                            class="times-container d-flex justify-content-end"
                                        >
                                            <app-tooltip class="travel-time-content last time-content position-top"
                                                         appCustomPopover
                                                         popoverText="{{ 'TRAVEL_TIME_TASK_TOOLTIP' | translate: {from: routeTasks[routeTasks.length - 1].address, to: (endLocationArrivalName | async)} }}"
                                                         placement="left"
                                            >
                                                <ng-container icon>
                                                    <span class="m-auto">{{ endLocationTravelTime + "'" }}</span>
                                                </ng-container>
                                            </app-tooltip>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <div
                            cdkDropList
                            [cdkDropListData]="routeTasks"
                            [cdkDropListDisabled]="dragDisabled"
                            (cdkDropListEntered)="entered($event)"
                            (cdkDropListDropped)="taskDropped($event)"
                            [cdkDropListSortingDisabled]="sortingDisabled"
                            class="d-flex flex-column h-100 w-100 mt-3">
                            @for (routeTask of routeTasks; track routeTask.taskId; let taskIndex = $index) {
                                <tr
                                    class="allocated-row"
                                    cdkDrag
                                    (cdkDragMoved)="onDragMoved($event)"
                                    [cdkDragData]="routeTask"
                                    (cdkDragStarted)="started($event)"
                                    [cdkDragDisabled]="!!routeTask.rideSharingConfig"
                                    (cdkDragReleased)="released()"
                                    (contextmenu)="openModalWindow(routeTask, $event)"
                                    [ngClass]="{'ride-sharing-table-row': routeTask.rideSharingConfig,
                                                'shift-split': routeTask.isShiftSplitTask,
                                                'colored': routeTask.color,
                                                'address-toggle-first-tr': taskIndex === 0 && addressToggleValue}"
                                    [ngStyle]="{'border-color': routeTask.color }"
                                >
                                    <td class="index-column" appTitleProvider>
                                        <span>{{ taskIndex + 1 }}</span>
                                    </td>
                                    <td class="flex-1" appTitleProvider>
                                        <span>{{ routeTask.name }}</span>
                                    </td>
                                    <td class="flex-3 task-description" appTitleProvider>
                                        @if (!routeTask.rideSharingConfig) {
                                            <span>
                                                {{ routeTask.serviceName }}
                                            </span>
                                        }
                                        @if (routeTask.rideSharingConfig) {
                                            <span>
                                                {{ routeTask.serviceName | translate: {employeeName: getRideSharingCompanionsName(routeTask)} }}
                                            </span>
                                        }
                                    </td>
                                    @if (showRoster) {
                                        <td class="flex-1" appTitleProvider>
                                            <span>{{ routeTask.rosterDepartmentName }}</span>
                                        </td>
                                    }
                                    <td class="flex-2"
                                        [ngClass]="{ 'cell-warning': routeTask.outsideTimeWindow && !highlightDelayVisualizationEnabled}"
                                        appTitleProvider>
                                        <span>
                                            {{ routeTask | fromto }}
                                        </span>
                                        @if (highlightDelayVisualizationEnabled && routeTask.taskDelaySeverity > DelayLevel.NoDelay) {
                                            <app-tooltip
                                                appCustomPopover
                                                placement="top"
                                                [popoverText]="getTaskDelayTooltip(routeTask)"
                                                [adaptPlacement]="true"
                                            >
                                                <ng-container icon>
                                                        <span
                                                            class="vismaicon vismaicon-sm ml-1"
                                                            [ngClass]="{
                                                'icon-warning-multicolor': routeTask.taskDelaySeverity === DelayLevel.ShortDelay,
                                                'icon-warning-multicolor-orange': routeTask.taskDelaySeverity === DelayLevel.MediumDelay,
                                                'icon-warning-multicolor-red': routeTask.taskDelaySeverity === DelayLevel.SevereDelay,
                                            }"
                                                        ></span>
                                                </ng-container>
                                            </app-tooltip>
                                        }
                                        @if (independentSyncTasksFeatureEnabled && routeTask.singleSyncedTask) {
                                            <app-tooltip
                                                appCustomPopover
                                                placement="top"
                                                popoverText="SYNCED_TASK_NOT_PAIRED_WARNING"
                                                [adaptPlacement]="true"
                                            >
                                                <ng-container icon>
                                                    <span
                                                        class="vismaicon vismaicon-sm ml-1 vismaicon-filled vismaicon-error"
                                                    ></span>
                                                </ng-container>
                                            </app-tooltip>
                                        } @else if (independentSyncTasksFeatureEnabled && routeTask.syncedTaskNotTimeSynced) {
                                            <app-tooltip
                                                appCustomPopover
                                                placement="top"
                                                popoverText="SYNCED_TASK_NOT_TIME_SYNCED"
                                                [adaptPlacement]="true"
                                            >
                                                <ng-container icon>
                                                    <span
                                                        class="vismaicon vismaicon-sm ml-1 vismaicon-filled vismaicon-error"
                                                    ></span>
                                                </ng-container>
                                            </app-tooltip>
                                        }
                                    </td>
                                    <td class="flex-2" appTitleProvider>
                                        <span>
                                            {{ routeTask.timeWindowStartTime }} - {{ routeTask.timeWindowEndTime }}
                                        </span>
                                    </td>
                                    <ng-container>
                                        <td class="icon-column two center-icons-gap-8">
                                            @if (routeTask.isHeavy) {
                                                <app-tooltip
                                                    appCustomPopover
                                                    popoverText="TASK_HEAVY_INFO"
                                                    placement="left"
                                                    [adaptPlacement]="true"
                                                >
                                                    <ng-container icon>
                                                        <span class="icon-heavy-weight"></span>
                                                    </ng-container>
                                                </app-tooltip>
                                            }
                                            @if (routeTask.isSynced) {
                                                <app-tooltip
                                                    class="ml-1"
                                                    appCustomPopover
                                                    [popoverText]="syncedTooltips.get(routeTask.taskId)"
                                                    placement="left"
                                                    [adaptPlacement]="true"
                                                >
                                                    <ng-container icon>
                                                        <span class="icon-merge"></span>
                                                    </ng-container>
                                                </app-tooltip>
                                            }
                                            @if (routeTask.doesRequirePhysicalAppearance === false) {
                                                <app-tooltip
                                                    class="ml-1"
                                                    appCustomPopover
                                                    popoverText="TASK_REQUIRE_PHYSICAL_APPEARANCE_INFO"
                                                    placement="left"
                                                    [adaptPlacement]="true"
                                                >
                                                    <ng-container icon>
                                                        <span class="icon-phone"></span>
                                                    </ng-container>
                                                </app-tooltip>
                                            }
                                        </td>
                                        <td class="icon-drag-column">
                                            <app-tooltip
                                                class="icon-drag-column"
                                                title="{{ 'DRAG_TASK' | translate}}"
                                                [compact]="true"
                                                [ngClass]="{'not-draggable': routeTask.rideSharingConfig}"
                                            >
                                                <ng-container icon>
                                                    <span class="vismaicon icon-draggable-indicator"></span>
                                                </ng-container>
                                            </app-tooltip>
                                        </td>
                                    </ng-container>
                                </tr>
                                @if (addressToggleValue && taskIndex !== routeTasks.length - 1) {
                                    <div
                                        class="mb-1"
                                    >
                                        @if (!routeTask.rideSharingConfig || routeTask.rideSharingConfig.action === 'DROP_OFF') {
                                            <span class="navigation-hint ml-5"
                                            >
                                                @if (showRideSharingTask(taskIndex) && employee.rideSharingRole === 'PASSENGER' && !routeTask.rideSharingConfig) {
                                                    {{ 'DRIVE_VERB' | translate }}
                                                } @else {
                                                    {{ ((employee.transport.toUpperCase() + '_VERB') | translate) }}
                                                }
                                                {{
                                                    ('TASK_NAVIGATION' | translate: {
                                                        from: (getTaskFromAddress(taskIndex + 1) | translate),
                                                        to: (getTaskToAddress(taskIndex + 1) | translate)
                                                    })
                                                }}
                                            </span>
                                        }
                                        @if (employee.transport === transportTypes.Walk && routeTask.rideSharingConfig && routeTask.rideSharingConfig.action !== 'DROP_OFF') {
                                            <span class="navigation-hint ml-5"
                                            >
                                                {{ ('RIDE_SHARING_RIDE_PASSENGER' | translate: {employeeName: getRideSharingCompanionsName(routeTask)}) }}
                                                {{
                                                    ('TASK_NAVIGATION' | translate: {
                                                        from: (getTaskFromAddress(taskIndex + 1) | translate),
                                                        to: (getTaskToAddress(taskIndex + 1) | translate)
                                                    })
                                                }}
                                            </span>
                                        }
                                        @if (employee.transport === transportTypes.Drive && routeTask.rideSharingConfig && routeTask.rideSharingConfig.action !== 'DROP_OFF') {
                                            <span class="navigation-hint ml-5"
                                            >
                                                {{ ('RIDE_SHARING_RIDE_DRIVER' | translate: {employeeName: getRideSharingCompanionsName(routeTask)}) }}
                                                {{
                                                    ('TASK_NAVIGATION' | translate: {
                                                        from: (getTaskFromAddress(taskIndex + 1) | translate),
                                                        to: (getTaskToAddress(taskIndex + 1) | translate)
                                                    })
                                                }}
                                            </span>
                                        }
                                    </div>
                                }
                            }
                        </div>
                    </div>
                    @if (showRestrictionContextMenu) {
                        <div
                            class="context-menu"
                            (click)="openEmployeesRestrictionModal()"
                            [style.top.px]="showRestrictionContextMenuTopPosition"
                            [style.left.px]="showRestrictionContextMenuLeftPosition"
                        >
                            <span class="vismaicon vismaicon-users vismaicon-no-hover"></span>
                            {{ 'SHOW_RESTRICTIONS' | translate }}
                        </div>
                    }
                </cdk-virtual-scroll-viewport>
            </ng-container>
        </app-table>
    }
    @if (pdfView) {
        <app-route-planning-pdf-view
            [routeTasks]="routeTasks"
            [employee]="employee"
            [showFreeTimeBetweenTasksFeature]="showFreeTimeBetweenTasksFeature"
            [showTaskDelayHighlight]="highlightDelayVisualizationEnabled"
        ></app-route-planning-pdf-view>
    }
</div>

@if (draggingTask && !employee.dropDisabled) {
    <div
        class="task-drop-enabled-info"
    >
        {{ 'ROUTE_PLANNING_TASK_DROP_DRAG_MESSAGE' | translate }}
    </div>
}

@if (draggingTask && employee.dropDisabled) {
    <div
        class="task-drop-disabled-info"
        [innerHTML]="'TASK_DROP_DISABLED_INFO' | translate"
    ></div>
}
